<template>
  <div class="white" >
    <v-container class="grey lighten-3">
      <br>
        <v-card>
            <h2 justify-content="center" align="center" text-align="center" class="pt-2 pb-4" >Camp-Card Reader</h2>
              <div class="px-4 pb-4" justify-content="center" align="center">
                <div justify-content="left">
                  <h3 class="mb-0" >Betrag</h3>
                  <input type="number" v-model="amount" class="mb-4 pl-4"/>
                  <span class="ml-2">CampTaler</span>
                </div>
                <div>
                <h3 class="mb-0">Verwendungszweck</h3>
                </div>
                <input label="Name" v-model="name" class="pl-4"/>
                <h2  v-if="showMessage" :class="{ 'red--text': isError, 'green--text': !isError }">{{ message }}</h2>
                <qr-scanner @scanned="scanComplete" @scanError="scanErr">

                </qr-scanner>
              </div>
        </v-card>
    </v-container>
  </div>
</template>

<script>
import QrScanner from '../components/QrScanner.vue';

export default {
  name: "Camp",
  components:{
    // Carousel
    QrScanner
  },
  data (){
    return {
      scanResult: null,
      amount: 0,
      name: "",
      message: "",
      showMessage: false,
      isError: false,
    }
  },
  
  watch: {
    message(newValue) {
      this.isError = this.message.startsWith("Fehler");
      if (newValue) {
        this.showMessage = true;
        setTimeout(() => {
          this.showMessage = false;
          this.message = "";
        }, 5000);
      }
    }
  },

  methods:{
    scanComplete(data) {
      this.scanResult = data;
      // daten an backend senden für php script
      if (this.scanResult && this.name && this.amount) {
        fetch("/php/addQrGameInfo.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: this.name,
            amount: this.amount,
            number: this.scanResult,
          }),
        })
        .then((response) => response.json())
        .then(() => {
          this.message = "Eingetragen";
        })
        .catch((error) => {
          this.message = "Fehler: " + error.message;
        });
      } else {
        this.message = "Fehler: Bitte Verwendungszweck und Betrag angeben.";
      }
    },

    scanErr() {
      this.message = "Fehler: Kein gültiger QR code";
    }
  },
  mounted (){    
  },
}
</script>

<style>
input{
  background-color: whitesmoke;
  min-height: 40px;
  padding: 0.5em;
  border-radius: 0.5em;
  font-size: 16px;
}
.leftStart{
  left: -100%;
  transition: left 0.5s;
}
.rightStart{
  left: 100%;
  transition: left 0.5s;
}

.slide{
  left: 0%
}

.customButton{
  margin-left : auto;
  margin-right : auto;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 400px;
  display: flex;
  justify-content: center;
}
</style>